import $ from 'zepto';
import { onDocumentReady } from '../main';
import { initToggleSlideElement } from '../utils';

const $body = $(document.body);

export function initAccordions(accordionClass, accordionSlideDuration, $context = $body) {
  const accordionItemClass = `${accordionClass}__item`;
  const closeAccordionItemClass = `${accordionItemClass}--close`;
  const accordionItemSelector = `.${accordionItemClass}`;
  const accordionHeaderSelector = `.${accordionClass}__header`;
  const accordionBodySelector = `.${accordionClass}__body`;

  function eachHeader(index, item) {
    const $accordionItem = $(item).closest(accordionItemSelector);
    initToggleSlideElement({
      $targetElement: $accordionItem.find(accordionBodySelector),
      $triggerElement: $accordionItem.find(accordionHeaderSelector),
      duration: accordionSlideDuration,
      callback({ isSlideDown }) {
        if (isSlideDown) {
          $accordionItem.removeClass(closeAccordionItemClass);
        } else {
          $accordionItem.addClass(closeAccordionItemClass);
        }
      },
    });
  }

  $context.find(accordionHeaderSelector).each(eachHeader);
  $context.find(accordionBodySelector)
    .hide()
    .attr('aria-hidden', true)
    .closest(accordionItemSelector)
    .addClass(closeAccordionItemClass);

  $context.find(accordionHeaderSelector)
    .attr('aria-expanded', false);
}

onDocumentReady('Accordions', () => {
  initAccordions('xvx-accordion', 300, $body);
});
export default {
  initAccordions,
};
